import React from "react";

const ITEMS = [
  "SITES",
  "SISTEMAS",
  "APLICATIVOS",
  "INTELIGÊNCIA ARTIFICIAL",
  "AUTOMAÇÃO",
  "SOLUÇÕES SOB MEDIDA",
];

const Marquee = () => (
  <section
    aria-hidden="true"
    className="overflow-hidden border-y border-white/10 bg-white/[0.015] py-6"
  >
    <div className="animate-marquee flex w-max items-center gap-12">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <div key={i} className="flex items-center gap-12">
          <span className="whitespace-nowrap font-display text-sm font-semibold tracking-[0.35em] text-white/35 md:text-base">
            {item}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-gradient-to-br from-[#00E5FF] to-[#8A2BE2]" />
        </div>
      ))}
    </div>
  </section>
);

export default Marquee;
